import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const MEMBER_UPDATE_TASK: BuiltInTaskDefinition = {
    slug: 'member-update',
    name: 'Update a member from a conversation',
    kind: 'llm',
    overlapPolicy: 'skip',
    concurrencySafe: true,
    serializeOn: null,
    builtInRole: 'org_change',
    chatPurpose: null,
    goal: 'Explain what changes on an existing member and why, write it as a plan, and get the CEO’s sign-off; the OS saves exactly the approved fields at their approval',
    metric: {
        text: 'Share of member-update conversations that reach CEO sign-off without a human re-explaining the request',
    },
    guardrails: [
        'Propose only — write the plan with os.write_plan; the OS saves the change once the CEO approves',
        'Show the current and proposed value for every field touched, and why it changes',
        'A member only, by memberId or memberHandle: never a person’s account',
    ],
    inputs: [
        {
            key: 'request',
            label: 'What the CEO wants changed',
            type: 'string',
            required: true,
        },
        {
            key: 'ceoNote',
            label: 'CEO note from a previous round',
            type: 'string',
            required: false,
        },
        {
            key: 'chatSessionId',
            label: 'Chat session this plan belongs to (chat fills it)',
            type: 'string',
            required: false,
        },
        {
            key: 'planKey',
            label: 'The conversation this plan belongs to when it has no chat session (the OS fills it)',
            type: 'string',
            required: false,
        },
    ],
    tools: ['os.directory', 'os.write_plan', 'os.read_plan', 'os.ask_ceo'],
    gates: [
        {
            tool: 'os.ask_ceo',
            owner: 'ceo',
            approval: 'specific',
        },
    ],
    spend: {
        moneyUsdPerRun: 1.5,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'member-update',
            on: 'ceo_approved',
            resumeConversation: true,
        },
        {
            slug: 'member-update',
            on: 'ceo_changes_requested',
        },
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    skillMd: TASK_TEXT['member-update.md'],
    adapterMd: TASK_TEXT['member-update.adapter.md'],
}
